export default "__VITE_ASSET__5dgCrMor__"